<template>
  <div class="seat-container">
    <div class="seat-id is-inline-block is-size-7" v-if="noSeat">
      &nbsp;
    </div>

    <b-tooltip
      v-else-if="!isSelectable && paidSeatNotSelectableClass"
      :label="tooltipMessage()"
      type="is-light"
      :position="orientation"
      multilined
    >
      <div
        class="seat-id is-inline-block is-size-7"
        :class="[paidSeatNotSelectableClass, 'with-price-tag']"
      >
        {{ seat.id }}
        <div class="price tag" v-if="seatPrice > 0">
          ${{ Math.ceil(seat.price.total) }}
        </div>
      </div>
    </b-tooltip>

    <b-tooltip
      v-else-if="isSelectable"
      :label="tooltipMessage()"
      type="is-light"
      :position="orientation"
      multilined
    >
      <div
        @click="selectSeat()"
        class="seat-id is-inline-block is-size-7 selectableSeat"
        :class="isSelectableStyleClass"
        :style="isSelected"
      >
        {{ seat.id }}
      </div>
    </b-tooltip>

    <div
      v-else-if="!isSelectable"
      class="seat-id is-inline-block is-size-7"
      :class="isSelectableStyleClass"
    >
      <b-icon icon="close" size="is-small"></b-icon>
    </div>

    <div class="price tag" v-if="seatPrice > 0 && isSelectable">
      ${{ Math.ceil(seat.price.total) }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    seat: Object,
    orientation: String,
    isSelected: {},
  },
  data() {
    return {
      seats: [],
    };
  },
  computed: {
    canPurchaseSeat() {
      let tripType = this.$store.getters["travellersAndTrips/getTravellers"]
        .tripType;

      //Allow Paid Seats for Personal Trips
      if (tripType === "personal") {
        return true;
      }

      const selectPaidSeats = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].selectPaidSeats;

      return selectPaidSeats === "Allow";
    },

    occupationLabel() {
      return this.seat.occupation.text ?? "";
    },
    seatPrice() {
      return this.seat.price?.total ?? 0;
    },

    isSelectable() {
      const isPaidSeat = this.seatPrice > 0;

      return this.seat.isSelectable && (!isPaidSeat || this.canPurchaseSeat);
    },
    isSelectableStyleClass() {
      if (this.isSelectable) {
        return "is-free";
      }

      return "is-unavailable";
    },

    paidSeatNotSelectableClass() {
      const isPaidSeat = this.seatPrice > 0;

      if (isPaidSeat && !this.canPurchaseSeat) {
        return "is-paid-not-selectable";
      }
      return "";
    },

    isOccupied() {
      return (
        this.seat.occupation.code == "O" || this.seat.occupation.code == "Z"
      );
    },
    seatExists() {
      return !this.noSeat;
    },
    noSeat() {
      let matched = this.seat.characteristics.find((char) => {
        return char.code == "8"; // no seat at this location
      });

      return matched;
    },
    characteristics() {
      let messageParts = [];

      if (this.seat.commercialName) {
        messageParts.push(this.seat.commercialName);
      }

      if (this.isOccupied || this.seat.characteristics.length == 0) {
        messageParts.push(this.seat.occupation.text);
      } else if (!this.seat.characteristics[0].text) {
        messageParts.push(this.seat.occupation.text);
      } else {
        this.seat.characteristics.forEach((char) => {
          if (isNaN(char.text)) {
            messageParts.push(char.text);
          }
          // messageParts.push(char.text)
        });
      }

      let message = messageParts.join(", ");

      return message;
    },
  },
  methods: {
    tooltipMessage() {
      if (!this.isSelectable && this.seatPrice > 0) {
        return "Your Company has disallowed selecting paid seats";
      } else {
        // Default message or other conditions
        return this.characteristics;
      }
    },
    selectSeat() {
      this.seat.characteristicsDisplay = this.characteristics.split(", ");

      this.seats.forEach((seat) => {
        this.resetStyle(seat);
      });
      this.$emit("selected", this.seat);
    },
    resetStyle(node) {
      node.style.background = "none";
      node.style.color = "#777";
    },
  },
  mounted() {
    this.seats = document.querySelectorAll(".selectableSeat");
    this.seats.forEach((seat) => {
      this.resetStyle(seat);
    });
  },
};
</script>

<style scoped>
.with-price-tag .price {
  position: absolute;
  top: -7px;
  right: 0px;
  background: #e0999f;
  color: white;
  line-height: 1rem;
  height: 1rem;
  padding: 0.2rem;
}

.is-paid-not-selectable {
  background: #eee;
  color: #bbb;
  border: 1px solid #f8d7da;
  position: relative;
}

.seat-container {
  position: relative;
  margin: 5px;
}

.price {
  position: absolute;
  top: -7px;
  right: 0px;
  background: green;
  color: white;
  line-height: 1rem;
  height: 1rem;
  padding: 0.2rem;
}

.seat-id.is-free {
  background: white;
  border: 1px solid #679fbf;
  cursor: pointer;
}

.seat-id.is-occupied {
  background: #eee;
  color: #bbb;
  border: 1px solid #ddd;
}

.seat-id.is-unavailable {
  background: #eee;
  color: #bbb;
}

.occupation.is-free {
  background: green;
  color: white;
}

@media screen and (max-width: 1023px) {
  .seat-id {
    padding: 2px;
    border-radius: 10px;
    min-width: 30px;
    min-height: 30px;
    line-height: 20px;
    text-align: center;
    background: #fff;
  }
}

@media screen and (min-width: 1024px) {
  .seat-id {
    padding: 5px;
    border-radius: 5px;
    min-width: 40px;
    min-height: 30px;
    line-height: 20px;
    text-align: center;
    background: #fff;
  }
}
</style>
